<template>
  <div>
    <div v-if="currentType === CUD_LIST_WHERE && typeCopy(currentItem)">模板筛选条件</div>
    <div v-else-if="currentType === CUD_LIST_PROEXEC">执行前提</div>
    <div v-else>筛选条件</div>
      <el-table
        :data="model"
        style="width: 100%">
        <el-table-column
          label="条件名">
          <template scope="scope">
            <el-input v-model="scope.row.name"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          v-if="currentType === CUD_LIST_WHERE"
          label="筛选字段">
          <template scope="scope">
            <el-select v-model="scope.row.field_id">
              <el-option v-for="option in fieldByModelId[currentItem.model_id]"
                :label="option.name + '(' + option.title + ')'"
                :value="option.field_id"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          v-if="currentType === CUD_LIST_PROEXEC"
          label="本表单字段">
          <template scope="scope">
            <el-select v-model="scope.row.field_id">
              <el-option v-for="option in flowFormField"
                :label="option.name + '(' + option.title + ')'"
                :value="option.field_id"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="逻辑"
          width="150">
          <template scope="scope">
            <el-select class="w-100" v-model="scope.row.logic">
              <el-option v-for="(option, optionIndex) in logicOptions"
                :label="option.name"
                :value="option.id">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          :label="showParamType()"
          width="200">
          <template scope="scope">
            <el-select class="w-150" v-model="scope.row.param_type">
              <el-option v-for="(option, optionIndex) in paramTypeOptions"
                          :label="option.name"
                          :value="option.id"
                          v-if="showParamTypeOptions(currentItem.deal_type, optionIndex)">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="值">
          <template scope="scope">
            <el-input v-model="scope.row.param" v-if="isText(scope.row)"></el-input>
            <el-select v-model="scope.row.param" v-else-if="isSelect(scope.row)">
              <el-option v-for="option in flowFormField"
                          :label="option.name + '(' + option.title + ')'"
                          :value="option.field_id">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="180"
          v-if="currentType === CUD_LIST_PROEXEC ||
                currentItem.deal_type == CUD_DEAL_UPDATE ||
                currentItem.deal_type == CUD_DEAL_DELETE ||
                currentItem.deal_type == CUD_DEAL_COPY">
          <template scope="scope">
            <el-button size="small" @click="deleteField(model, scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="tx-c m-t-10"
        v-show="currentType === CUD_LIST_PROEXEC ||
                currentItem.deal_type == CUD_DEAL_UPDATE ||
                currentItem.deal_type == CUD_DEAL_DELETE ||
                currentItem.deal_type == CUD_DEAL_COPY">
        <el-button type="primary" @click="addField(model, 'where')">添加</el-button>
      </div>
      <div>
        <div>条件逻辑关系</div>
        <div v-if="currentType === CUD_LIST_PROEXEC">
          <el-input type="textarea" v-model="currentItem.pre_exec_logic_relation" 
            :disabled="model.length === 0" 
            @change="resetCheckPreExecResult(currentItem, currentItem.pre_exec_logic_relation)"></el-input>
          <el-button type="primary" size="small" @click="checkPreExecRelateion(currentItem, currentItem.pre_exec_logic_relation)" 
            :disabled="currentItem.pre_exec_logic_exec_result">检查是否正确</el-button>
        </div>
        <div v-if="currentType === CUD_LIST_WHERE">
          <el-input type="textarea" v-model="currentItem.logic_relation" 
            :disabled="model.length === 0" 
            @change="resetCheckResult(currentItem, currentItem.logic_relation)"></el-input>
          <el-button type="primary" size="small" @click="checkLogicRelateion(currentItem, currentItem.logic_relation)" 
            :disabled="currentItem.logic_exec_result">检查是否正确</el-button>
        </div>
        <div class="form-tips lh-20">
          说明：为空则全部条件为AND关系，填写条件名和AND、OR以及括号、双引号（均为英文半角）来组合条件间的关系，慎重以免报错，若解析失败，则会以全部为AND来解析。<br>&nbsp;&nbsp;&nbsp;&nbsp;填写例子：("条件名1"AND"条件名2")OR("条件名1"AND"条件名3")
        </div>
      </div>
  </div>
</template>
<style>

</style>

<script>
  import http from '../../../assets/js/http'
  import flowConfig from '../../../config/flowConfig'
  export default {
    props: ['currentItem', 'paramTypeOptions', 'logicOptions', 'fieldByModelId', 'flowFormField', 'currentType', 'loadings', 'currentIndex'],
    data() {
      return {
        whereModel: { // 筛选条件配置数据结构
          field_id: '',     // 字段id
          logic: 10,        // 逻辑
          name: '',         // 条件名
          param: '',        // 参数值
          param_type: 10    // 参数类型
        },
        model: []
      }
    },
    created() {
      this.model = _.cloneDeep([])
      this.model = this.currentType === this.CUD_LIST_WHERE ? this.currentItem.where : this.currentItem.pre_exec
    },
    methods: {
      showFieldName() {
        return this.currentType === this.CUD_LIST_WHERE ? '筛选字段' : '本表单字段'
      },
      showParamType() {
        return this.currentType === this.CUD_LIST_WHERE ? '传入类型' : '值类型'
      },
      showParamTypeOptions(type, index) {
        let arr = this.paramTypeOptions
        if (this.currentType === this.CUD_LIST_PROEXEC) { // 执行前提加入限制
          if (index === 0 || index === 2) {
            return true
          }
          return false
        }
        if (index === 3 || index === 4 || index === 5 || index === 6) {
          return false
        }
        if (type != this.CUD_DEAL_COPY) {
          if (index === 7) {
            return false
          }
        }
        return true
      },
      isText(currentItem) {  // 输入框
        return currentItem.param_type == this.CUD_PARAM_CONST || // 常量
               currentItem.param_type == this.CUD_PARAM_DATE || // 日期变量
               currentItem.param_type == this.CUD_PARAM_CUMULATIVE_CONSTANT     // 累加常量
      },
      isSelect(currentItem) { // 下拉框
        return currentItem.param_type == this.CUD_PARAM_FORMVALUE ||
               currentItem.param_type == this.CUD_PARAM_CUMULATIVE_VARIABLE || // 累加变量
               currentItem.param_type == this.CUD_PARAM__SUBTRACT_VARIABLE ||
               currentItem.param_type == this.CUD_PARAM_TEMPLATE
      },
      typeCopy(item) {  // 复制类型
        return item.deal_type == this.CUD_DEAL_COPY
      },
      deleteField(item, index) { // 删除参数
        item.splice(index, 1)
      },
      addField(item, type) {  // 添加参数
        if (type == 'where') { // 筛选条件
          item.push(_.cloneDeep(this.whereModel))
        }
      },
      resetCheckPreExecResult(item, value) {  // 重置执行结果
        item.pre_exec_logic_exec_result = false
      },
      resetCheckResult(item, value) {  // 重置执行结果
        item.logic_exec_result = false
      },
      checkValueFormat(value) {
        let vailed = true
        if (!value) {
          return false
        }
        if (this.model && this.model.length > 0) {
          _(this.model).forEach((res) => {
            if (!res.name) {
              return
            }
            if (!(value.indexOf(res.name) > -1)) {
              vailed = false
            }
          })
        }
        return vailed
      },
      async checkPreExecRelateion(item) {
        if (!this.checkValueFormat(item.pre_exec_logic_relation)) {
          _g.toastMsg(this, 'warning', '执行前提条件名与逻辑关系不符合')
          return
        }
        let target_model_id = item.template_model_id ? item.template_model_id : item.model_id
        if (_g.isRealEmpty(target_model_id)) {
          _g.toastMsg(this, 'warning', '请先选择表单')
          return
        }
        let postData = {
          pre_exec: item.pre_exec,
          pre_exec_logic_relation: item.pre_exec_logic_relation,
          type: 20,
          logic_relation: [],
          target_model_id: target_model_id,
          this_model_id: item.this_model_id,
          where: []
        }
        let res = await this.apiPost('cms/deals/check_relation_field', postData)
        if (res.code == 200) {
          _g.toastMsg(this, 'success', res.data)
          item.pre_exec_logic_exec_result = true
        } else {
          _g.dealError(this, res)
        }
      },
      async checkLogicRelateion(item) { // 检查逻辑语句是否正确
        if (!this.checkValueFormat(item.logic_relation)) {
          _g.toastMsg(this, 'warning', '筛选条件名与逻辑关系不符合')
          return
        }
        let target_model_id = item.template_model_id ? item.template_model_id : item.model_id
        if (_g.isRealEmpty(target_model_id)) {
          _g.toastMsg(this, 'warning', '请先选择表单')
          return
        }
        let postData = {
          pre_exec: [],
          pre_exec_logic_relation: '',
          type: 10,
          logic_relation: item.logic_relation,
          target_model_id: target_model_id,
          this_model_id: item.this_model_id,
          where: item.where
        }
        let res = await this.apiPost('cms/deals/check_relation_field', postData)
        if (res.code == 200) {
          _g.toastMsg(this, 'success', res.data)
          item.logic_exec_result = true
        } else {
          _g.dealError(this, res)
        }
      }
    },
    watch: {
      model() {
        if (this.model && this.model.length === 0) {
          if (this.currentType === this.CUD_LIST_WHERE) {
            this.currentItem.logic_relation = ''
          } else {
            this.currentItem.pre_exec_logic_relation = ''
          }
        }
      }
    },
    mixins: [http, flowConfig]
  }
</script>



// WEBPACK FOOTER //
// conditionConfig.vue?1b6bd818